import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { getFullUrl } from 'hubspot-url-utils';
import { trackClickedLink } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
export const PublicSetUpPaymentsCTA = ({
  use = 'secondary',
  block = false,
  screen,
  trackingSource
}) => /*#__PURE__*/_jsx(Button, {
  use: use,
  block: block,
  onClick: () => {
    const setupUrl = `${getFullUrl('app')}/l/revenue/zero-state`;
    trackClickedLink({
      type: 'internal',
      url: setupUrl,
      name: 'Set up payments',
      screen,
      trackingSource
    });
    window.location.href = setupUrl;
  },
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "publicPricingPage.merchCard.cta.setupPayments"
  })
});